export enum ButtonAction {
  ViewReminder = 'viewReminder',
  MarkAsComplete = 'markAsComplete',
}
